var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDefaultTheme = exports.getDefaultTheme = void 0;

var lodash_1 = require("lodash");

var styles_1 = require("@material-ui/core/styles");

var useTheme_1 = __importDefault(require("@material-ui/core/styles/useTheme"));

var Themes_1 = require("../../Themes");

exports.getDefaultTheme = function (providerTheme) {
  var parsedProviderTheme = JSON.parse(JSON.stringify(providerTheme)),
      parsedDefaultTheme = JSON.parse(JSON.stringify(styles_1.createMuiTheme({})));

  if (lodash_1.isEqual(parsedProviderTheme, parsedDefaultTheme)) {
    return styles_1.createMuiTheme(Themes_1.themes.natura.light);
  }

  return providerTheme;
};

exports.useDefaultTheme = function () {
  var providerTheme = useTheme_1.default();
  return exports.getDefaultTheme(providerTheme);
};

exports.default = exports.useDefaultTheme;